// Horizontal tab bar — primary navigator for the planner page.
import {
  LayoutDashboard,
  Target,
  CheckSquare,
  Flag,
  Lightbulb,
  Users,
  Activity,
  type LucideIcon,
} from "lucide-react";
import { PLANNER_VIEWS, type PlannerViewId } from "../../../../../../shared/team-planner/const";

const ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  Target,
  CheckSquare,
  Flag,
  Lightbulb,
  Users,
  Activity,
};

export function TabBar({
  active,
  onSelect,
}: {
  active: PlannerViewId;
  onSelect: (v: PlannerViewId) => void;
}) {
  return (
    <nav role="tablist" aria-label="Planner sections" className="tp-tabbar">
      {PLANNER_VIEWS.map((v) => {
        const Icon = ICONS[v.icon] ?? Target;
        return (
          <button
            key={v.id}
            type="button"
            role="tab"
            aria-selected={v.id === active}
            onClick={() => onSelect(v.id)}
            className="tp-tab"
          >
            <Icon size={14} aria-hidden />
            <span>{v.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
